import React from "react";
import OtpInput from "react-otp-input";
// import OTPInput from "./otpInput";
// import './otpInput.css';

const CustomOtpInput = (props) => {
  return (

    <OtpInput
      placeholder={props.placeholder || "1234"}
      inputType="number"
      value={props.value}
      onChange={props.onChange}
      numInputs={props.numInputs || 4}
      renderSeparator={<span>-</span>}
      renderInput={(props) => <input {...props} />}
      inputStyle={props.inputStyle}
      containerStyle={props.containerStyle}
      shouldAutoFocus={props.shouldAutoFocus}
    />
    /*
    <OTPInput
      autoFocus
      isNumberInput
      length={4}
      className="otpContainer"
      inputClassName="otpInput"
      onChangeOTP={props.onChange}
    />*/
  );
};

export default CustomOtpInput;
